import { Link } from "react-router-dom";
import logo from "../../assets/logo1.png";

const Navbar = () => {
  const token = localStorage.getItem("token");

  return (
    <header className="w-full bg-primary/80 border-b border-bkg flex justify-between items-center px-5 py-4 rounded-xl ">
      <div>
        <Link to="/">
          <img src={logo} alt="logo" className="h-10" />
        </Link>
      </div>
      <nav className="flex items-center gap-4 bg-content rounded-full md:flex">
        <Link className="nav-home" to="/dashboard">
          Dashboard
        </Link>
        <Link className="nav-home hidden sm:block " to="/#features">
          Features
        </Link>
        <Link className="nav-home hidden sm:block" to="/#about-us">
          About Us
        </Link>
        {!token && (
          <>
            <Link className="nav-home" to="/login">
              Login
            </Link>
            {/* <Link className="nav-home" to="/register">
              Register
            </Link> */}
          </>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
